'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncApiSymbol = require('./asyncApiSymbol');

var _asyncApiSymbol2 = _interopRequireDefault(_asyncApiSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _defineProperty({
  get: function get(key, cb) {
    return chrome.storage.local.get(key, function (result) {
      // Chrome's StorageArea returns an object for
      // some reason.
      cb(result[key]);
    });
  },
  set: function set(key, value, cb) {
    return chrome.storage.local.set(_defineProperty({}, key, value), cb);
  }
}, _asyncApiSymbol2.default, true);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/storage/chromeStorage.js
// module id = 461
// module chunks = 0